import React, { useState } from "react";
import { TextField, Grid, Input, Button, InputLabel, Tooltip } from "@mui/material";
import  { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

import { localStorageFunc } from "../../../../helpers/utility";
import useStyles from "./styles";
import PhonePausedIcon from '@mui/icons-material/PhonePaused';

function DisposeDialPhone(props) {
  const classes = useStyles();
  const [MuteBtn, setMuteBtn] = useState("Mute");
  const selectedWebrtc = localStorageFunc.get("loginType") === "Webrtc" ? true : false;

  const handleClick = (e) => {
    setMuteBtn(e.target.value === "Mute" ? "Unmute" : "Mute");
    window.muteCall(e.target, "agentui");
  };

  const handleFrame = (e) => {
    window.showUser(props.phoneNum, props.agentId, props.campaignId);
  };

  // Tootlip study
  const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -14],
              },
            },
          ],
        },
      }}/>
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#fff',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(14),
      border: '1px solid #dadde9',

    },
  }));

  const handleCopy = (text) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          console.log("Copied to clipboard!");
        })
        .catch((err) => {
          console.error("Failed to copy: ", err);
        });
    } else {
      // Fallback for unsupported environments
      const textarea = document.createElement("textarea");
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand("copy");
        console.log("Fallback: Copied to clipboard!");
      } catch (err) {
        console.error("Fallback failed: ", err);
      } finally {
        document.body.removeChild(textarea);
      }
    }
  };

  const truncatedValue = props.ivrsPath && props.ivrsPath.length > 30
    ? props.ivrsPath.substring(0, 25) + "..."
    : props.ivrsPath;
  return (
    <>
    <Grid container spacing={2} alignItems="center">
      {/* TextField */}
      <Grid item >
        <TextField
          label={props.label}
          variant="outlined"
          size="small"
          value={props.value}
          fullWidth
        />
      </Grid>

      {/* IVRS Path Button */}
      {props.ivrsPath && (
  <Grid item style={{ position: "relative" }}>
    <InputLabel
      size="small"
      style={{
        position: "absolute",
        top: "-12px",
        insetInlineStart: "30px",
        backgroundColor: "#f6f7ff",
        zIndex: "999999",
        fontSize: "14px",
      }}
    >
      IVR Path
    </InputLabel>
    <HtmlTooltip
        title={
          props.ivrsPath
        }
      >
      <Button
        variant="outlined"
        onClick={() => handleCopy(props.ivrsPath)}
        sx={{
          color: "#000", 
          borderColor: "#d2d3da", 
          paddingTop: "6.5px",
          paddingBottom: "6.5px",
          paddingInline: "12px",
          "&:hover": {
            color: "primary.main", 
            borderColor: "primary.main", 
            backgroundColor: "transparent", 
          },
        }}
      >
        {truncatedValue}
      </Button>
      </HtmlTooltip>
  </Grid>
)}


      {/* Mute/Unmute Button */}
      
      {selectedWebrtc && (
          <Input
            type="button"
            variant="outlined"
            //size="small"
            value={MuteBtn}
            style={{
              border: "1px solid #0000ff",
              textTransform: "capitalize",
              marginInlineStart: "12px",
              marginInlineEnd: "10px"
            }}
            className={classes.ConferenceButton}
            onClick={(e) => handleClick(e)}
          />
      )}
    
    {/* Call Park Option*/}
     {
      props.callPark === "1" &&(
        <Button
        variant="outlined"
        onClick={props.handleCallPark}
        sx={{
          color: "#FF5C93", 
          borderColor: "#FF5C93", 
          paddingTop: "6.5px",
          paddingBottom: "6.5px",
          paddingInlineStart: "12px",
          paddingInlineEnd: "12px",
          "&:hover": {
            color: "primary.main", 
            borderColor: "primary.main", 
            backgroundColor: "transparent", 
          },
        }}
      >
      <PhonePausedIcon /> Park Call
      </Button>
      )
     }    
      

      {/* Show Transcript Button */}
      {window.Configs.var2 === 1 && (
        <Grid item>
          <Input
            type="button"
            variant="outlined"
            value="Show Transcript"
            style={{
              textTransform: "capitalize",
              border: "1px solid #0000ff",
              marginInlineStart: "12px",
              width: "140px",
            }}
            className={classes.ConferenceButton}
            onClick={handleFrame}
          />
        </Grid>
      )}

     
    </Grid>
    <iframe
    src=""
    title="transcriptFrame"
    id="iframeData"
    frameBorder="0"
    width="342vw"
    height="517px"
    style={{
      display: "none",
      position: "fixed",
      bottom: 0,
      insetInlineStart: "75vw",
      zIndex: 999,
    }}
    scrolling="auto"
  ></iframe>
  </>
  );
}

export default DisposeDialPhone;
